const pdfMake = require('pdfmake/build/pdfmake');
const pdfFonts = require('pdfmake/build/vfs_fonts');
// const fs = require('fs');
console.log(123)
pdfMake.vfs = pdfFonts.vfs;

function genPieSvg(redPercent, greenPercent) {

    // Convert percentages to angles
    const redAngle = (redPercent / 100) * 360;
    const greenAngle = (greenPercent / 100) * 360;
    const blueAngle = 360 - redAngle - greenAngle;

    // Define the colors for each segment
    const segments = [
        {angle: redAngle, color: '#E0818C'},   // Red segment
        {angle: blueAngle, color: '#ECDB71'}, // Green segment
        {angle: greenAngle, color: '#68C47A'}   // Blue segment
    ];

    // SVG dimensions and center point
    const width = 56;
    const height = 56;
    const cx = width / 2;
    const cy = height / 2;
    const outerRadius = 28;
    const innerRadius = 14; // Adjust the inner radius for the donut hole size

    // Helper function to convert polar coordinates to cartesian
    function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
        return {
            x: centerX + radius * Math.cos(angleInRadians),
            y: centerY + radius * Math.sin(angleInRadians)
        };
    }

    // Function to create a path for a donut segment
    function createDonutSegmentPath(startAngle, endAngle) {
        const startOuter = polarToCartesian(cx, cy, outerRadius, endAngle);
        const endOuter = polarToCartesian(cx, cy, outerRadius, startAngle);
        const startInner = polarToCartesian(cx, cy, innerRadius, startAngle);
        const endInner = polarToCartesian(cx, cy, innerRadius, endAngle);

        const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

        const pathData = [
            'M', startOuter.x, startOuter.y,
            'A', outerRadius, outerRadius, 0, largeArcFlag, 0, endOuter.x, endOuter.y,
            'L', startInner.x, startInner.y,
            'A', innerRadius, innerRadius, 0, largeArcFlag, 1, endInner.x, endInner.y,
            'Z'
        ].join(' ');

        return pathData;
    }

    // Generate paths for each segment
    let cumulativeAngle = 0;
    const paths = segments.map(segment => {
        const startAngle = cumulativeAngle;
        const endAngle = cumulativeAngle + segment.angle;
        const path = createDonutSegmentPath(startAngle, endAngle);
        cumulativeAngle = endAngle;
        return `<path d="${path}" fill="${segment.color}" stroke="white" stroke-width="2"/>`;
    });

    // Construct the SVG
    const svgContent = `
    <svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg">
      ${paths.join('\n')}
    </svg>
  `;

    return svgContent;
}

const logo = `<svg width="94" height="50" viewBox="0 0 94 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M65.443 2.97619V7.14544C74.1372 7.71798 81.1712 14.56 82.0506 23.1736C82.0857 23.5169 81.8118 23.8095 81.467 23.8095C81.154 23.8095 80.8953 23.5666 80.8628 23.2551C80.0268 15.2612 73.5071 8.90813 65.443 8.33873C64.785 8.33574 64.2532 7.8012 64.2532 7.14284V2.97619C64.2532 2.64745 64.5195 2.38095 64.8481 2.38095C65.1767 2.38095 65.443 2.64745 65.443 2.97619ZM62.4279 7.1961C62.7709 7.16117 63.0633 7.43514 63.0633 7.78009C63.0633 8.09333 62.8203 8.35212 62.509 8.38461C54.5193 9.21808 48.1714 15.7408 47.5979 23.8067C47.5978 23.8083 47.5965 23.8095 47.5949 23.8095C47.5964 24.4665 47.0645 25 46.4078 25H42.2404C41.9119 25 41.6455 24.7335 41.6455 24.4048C41.6455 24.076 41.9119 23.8095 42.2404 23.8095H46.405C46.9803 15.1117 53.8178 8.07299 62.4279 7.1961ZM47.646 26.7453C48.4763 34.7447 54.9951 41.0942 63.0633 41.6639C63.7204 41.6639 64.2531 42.1968 64.2531 42.8543V47.0238C64.2531 47.3526 63.9867 47.619 63.6582 47.619C63.3296 47.619 63.0632 47.3525 63.0632 47.0238L63.0633 42.8571C54.3647 42.2843 47.3315 35.4454 46.458 26.8259C46.4233 26.4828 46.6971 26.1905 47.0417 26.1905C47.3549 26.1905 47.6136 26.4337 47.646 26.7453ZM65.9974 41.6154C65.686 41.6479 65.443 41.9067 65.443 42.2199C65.443 42.5649 65.7354 42.8388 66.0784 42.8039C74.6929 41.9272 81.5346 34.8942 82.104 26.1905H86.2658C86.5944 26.1905 86.8608 25.924 86.8608 25.5952C86.8608 25.2665 86.5944 25 86.2658 25H82.1013C81.4441 25 80.9114 25.533 80.9114 26.1905C80.345 34.2637 73.9923 40.782 65.9974 41.6154ZM54.5691 32.1429C54.2066 32.1429 54.1125 31.9127 54.2868 31.4523L59.4948 17.7769C59.6551 17.3514 59.8852 17.1387 60.185 17.1387H61.6491C61.9489 17.1387 62.179 17.3514 62.3393 17.7769L67.5473 31.4523C67.7216 31.9127 67.6275 32.1429 67.265 32.1429H66.1983C65.8288 32.1429 65.5778 31.972 65.4453 31.6302L64.1381 28.1669H57.696L56.3888 31.6302C56.2563 31.972 56.0053 32.1429 55.6358 32.1429H54.5691ZM58.3549 26.4509H63.4792L61.8792 22.2656C61.7328 21.875 61.5864 21.4425 61.4399 20.9682C61.3005 20.4939 61.1332 19.8207 60.938 18.9488H60.8961C60.7009 19.8207 60.5301 20.4939 60.3837 20.9682C60.2443 21.4425 60.1013 21.875 59.9549 22.2656L58.3549 26.4509ZM70.0677 32.1429C69.7191 32.1429 69.5448 31.951 69.5448 31.5674V17.7141C69.5448 17.3305 69.7191 17.1387 70.0677 17.1387H71.0298C71.3784 17.1387 71.5527 17.3305 71.5527 17.7141V31.5674C71.5527 31.951 71.3784 32.1429 71.0298 32.1429H70.0677Z" fill="#0E0C0D"/>
<path d="M9.44001 32.1429C9.09141 32.1429 8.91711 31.951 8.91711 31.5674V17.7141C8.91711 17.3305 9.09141 17.1387 9.44001 17.1387H10.4021C10.7507 17.1387 10.925 17.3305 10.925 17.7141V31.5674C10.925 31.951 10.7507 32.1429 10.4021 32.1429H9.44001Z" fill="#0E0C0D"/>
<path d="M13.6545 22.5377C13.3408 22.5377 13.1839 22.4156 13.1839 22.1715V21.5227C13.1839 21.2786 13.3408 21.1565 13.6545 21.1565H14.8886V20.2148C14.8886 20.0753 14.9234 19.9428 14.9931 19.8172L15.7252 18.4884C15.8577 18.2443 15.9657 18.1222 16.0494 18.1222H16.4154C16.6246 18.1222 16.7291 18.2443 16.7291 18.4884V21.1565H18.9567C19.2704 21.1565 19.4273 21.2786 19.4273 21.5227V22.1715C19.4273 22.4156 19.2704 22.5377 18.9567 22.5377H16.7291V29.2027C16.7291 29.9351 16.8372 30.4129 17.0533 30.6362C17.2764 30.8524 17.5414 30.9605 17.8481 30.9605C18.0852 30.9605 18.3675 30.8908 18.6952 30.7513C19.0299 30.6117 19.2599 30.4932 19.3854 30.3955C19.5109 30.2979 19.6085 30.3292 19.6783 30.4897L20.0234 31.2953C20.0791 31.4348 20.0373 31.5465 19.8979 31.6302C19.626 31.7906 19.2286 31.9475 18.7057 32.101C18.1828 32.2475 17.6599 32.3207 17.137 32.3207C16.4119 32.3207 15.8542 32.0592 15.4637 31.536C15.0803 31.0128 14.8886 30.2734 14.8886 29.3178V22.5377H13.6545Z" fill="#0E0C0D"/>
<path d="M22.6483 18.9907C22.3346 18.9907 22.1777 18.8337 22.1777 18.5198V17.2433C22.1777 16.9294 22.3346 16.7725 22.6483 16.7725H23.8614C24.1751 16.7725 24.332 16.9294 24.332 17.2433V18.5198C24.332 19.2522 24.2518 19.894 24.0915 20.445C23.9381 20.9891 23.6313 21.4669 23.1712 21.8785C23.0178 22.011 22.8888 22.0285 22.7843 21.9308L22.3136 21.4914C22.2091 21.3937 22.2335 21.2751 22.3869 21.1356C22.6239 20.9263 22.8156 20.6264 22.962 20.2358C23.1154 19.8382 23.1921 19.4231 23.1921 18.9907H22.6483Z" fill="#0E0C0D"/>
<path d="M26.8942 31.1175C26.6781 30.9152 26.6327 30.7268 26.7582 30.5525L27.2288 29.8933C27.3822 29.684 27.6088 29.6945 27.9086 29.9247C28.32 30.2386 28.7766 30.4897 29.2786 30.678C29.7875 30.8664 30.3662 30.9605 31.0146 30.9605C31.3981 30.9605 31.7397 30.9152 32.0395 30.8245C32.3393 30.7268 32.6007 30.549 32.8238 30.2909C33.0539 30.0328 33.1689 29.6875 33.1689 29.255C33.1689 29.0039 33.1131 28.7667 33.0016 28.5435C32.897 28.3203 32.7297 28.1424 32.4996 28.0099C32.2765 27.8704 32.0569 27.7623 31.8408 27.6855C31.4852 27.553 31.1296 27.4449 30.7741 27.3612C30.4255 27.2705 29.9653 27.1345 29.3936 26.9531C29.0102 26.8345 28.6476 26.6671 28.306 26.4509C27.9644 26.2277 27.6646 25.9277 27.4066 25.5511C27.1556 25.1744 27.0301 24.6547 27.0301 23.992C27.0301 23.3154 27.2358 22.733 27.6472 22.2447C28.0585 21.7564 28.5744 21.4251 29.1949 21.2507C29.8154 21.0693 30.4185 20.9787 31.0041 20.9787C31.8687 20.9787 32.5624 21.0798 33.0853 21.2821C33.6151 21.4774 34.0718 21.7111 34.4552 21.9831C34.6783 22.1436 34.7097 22.3284 34.5494 22.5377L34.0788 23.1655C33.9323 23.3677 33.7058 23.3608 33.399 23.1445C33.141 22.9632 32.775 22.7923 32.3009 22.6318C31.8268 22.4714 31.412 22.3912 31.0564 22.3912C30.6172 22.3912 30.2407 22.44 29.927 22.5377C29.6132 22.6353 29.3588 22.8027 29.1636 23.0399C28.9683 23.2771 28.8707 23.5561 28.8707 23.877C28.8707 24.1211 28.9091 24.3408 28.9858 24.5361C29.0625 24.7245 29.2054 24.8989 29.4145 25.0593C29.6237 25.2197 29.9165 25.3488 30.293 25.4464C30.8786 25.5999 31.412 25.7394 31.8931 25.865C32.3811 25.9905 32.8203 26.144 33.2107 26.3253C33.7197 26.5625 34.1101 26.8241 34.382 27.1101C34.6609 27.3961 34.8526 27.7065 34.9572 28.0413C35.0618 28.3691 35.1141 28.7354 35.1141 29.1399C35.1141 29.8863 34.891 30.5176 34.4448 31.0338C34.0055 31.5499 33.514 31.8952 32.9702 32.0696C32.4264 32.237 31.771 32.3207 31.0041 32.3207C29.9653 32.3207 29.0729 32.1742 28.3269 31.8813C27.5879 31.5813 27.1103 31.3267 26.8942 31.1175Z" fill="#0E0C0D"/>
</svg>
`


function _createScanReportPDF(text, aiPercent, humanPercent, deep = false) {
    const plotSvg = genPieSvg(aiPercent, humanPercent)
    const scannedText = text;

    function countWords(s) {
        s = s.replace(/(^\s*)|(\s*$)/gi, "");//exclude  start and end white-space
        s = s.replace(/[ ]{2,}/gi, " ");//2 or more space to 1
        s = s.replace(/\n /, "\n"); // exclude newline with a start spacing
        return s.split(' ').filter(function (str) {
            return str != "";
        }).length;
    }

    const options = {
        rectWidth: 563,
        height: 842,
        detailsHeight: 94,
        scanResultHeight: 172,
        headerHeight: 72,
        breakdownHeight: 139,
        blocksGap: 8,
        borderColor: '#EDF1F9',
        borderRadius: 8,
    }
    if (!deep) {
        options.breakdownHeight = 0;
    }

    function cumulativeHeight(initialValue = 0) {
        let height = initialValue;
        return function (value = 0) {
            height += value
            return height
        }
    }

    const heightCalc = cumulativeHeight()
    const date = new Date()
    const rectOpt = {
        type: 'rect',
        x: 0,
        y: 0,
        w: options.rectWidth,
        r: options.borderRadius,
        color: "#FFFFFF",
        lineColor: options.borderColor,
    }

    const circle = (fill, stroke) => `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="6" fill="${fill}"/>
        <circle cx="6" cy="6" r="5.5" stroke="${stroke}" stroke-opacity="0.75"/>
    </svg>`

    const posHelper = (x = 0, y = 0) => {
        const pos = {x: x, y: y}
        return (shiftX = 0, shiftY = 0, set = false) => {
            const res = {...pos, x: pos.x + shiftX, y: pos.y + shiftY}
            if (set) {
                pos.x += shiftX
                pos.y += shiftY
            }
            return res
        }
    }
    const mixedPercent = 100 - (aiPercent + humanPercent);

    const resSign = {
        text: 'Mixed',
        color: "#6A4E17",
        fontSize: 16,
        bold: true,
        relativePosition: {x: -93 - 12 + 24, y: 10.5}
    }
    const resSignCanvas = {
        type: 'rect',
        x: 0,
        y: 0,
        w: 93,
        h: 38,
        r: options.borderRadius,
        color: "#F6DC99",
    }
    if (aiPercent > humanPercent && aiPercent > mixedPercent) {
        resSign.text = 'AI'
        resSign.color = "#86414a"
        resSignCanvas.color = "#F2D9D8"
        resSignCanvas.w = 65
        resSign.relativePosition.x += 28
    }
    if (humanPercent > aiPercent && humanPercent > mixedPercent) {
        resSign.text = 'Human'
        resSign.color = "#296e38"
        resSignCanvas.color = "#DAF2D8"
        resSign.relativePosition.x -= 3
    }

    let content = [
        {
            "columns": [
                {text: 'Scan report', style: 'header', width: "25%"},
                {
                    width: "*",
                    text: 'Date: ' + date.toLocaleString(),
                    alignment: 'left',
                    margin: [120, 8, 0, 20],
                    color: "#A6A8B0",
                    fontSize: 12
                },

            ]
        },
        {text: "It's AI", link: "https://its-ai.org", absolutePosition: {x: 180, y: 28}, style: "link"},
        {svg: logo, absolutePosition: {x: 480, y: heightCalc() + 10}},
        {
            margin: [0, 16, 0, 0],
            canvas: [
                {
                    ...rectOpt,
                    h: options.scanResultHeight + options.breakdownHeight,
                },
            ],
            absolutePosition: {x: 16, y: heightCalc(options.headerHeight)},
        },
        {
            stack: [
                {
                    margin: [24, 20, 0, 0],
                    text: 'Scan result', style: 'subheader'
                },
                {
                    margin: [24, 12, 0, 0],
                    "columns": [
                        {
                            width: "auto",
                            text: aiPercent + '% AI',
                            fontSize: 32,
                        },
                        {
                            width: "auto",
                            margin: [12, 0, 12, 2.5],
                            canvas: [
                                resSignCanvas,
                            ],
                        },
                        resSign
                    ]
                },
                {
                    margin: [24, 12],
                    style: 'text',
                    text: `Your text is a mix of AI-generated and human-written text resulting on ${aiPercent}% probability of being AI-generated.`,
                },
            ],
            relativePosition: {y: 16},
        },
    ]
    let start = posHelper(16, heightCalc(options.scanResultHeight))
    if (deep)
        content = [...content,
            // PROBABILITY BREAKDOWN
            {
                absolutePosition: start(),
                svg: `<svg width="${options.rectWidth}" height="2">
      <line x1="0" y1="0" x2="${options.rectWidth}" y2="0" style="stroke:#EDF1F9;stroke-width:2" />
    </svg>`
            },
            {
                stack: [
                    {
                        margin: [20, 20, 0, 0],
                        text: 'Probability breakdown', style: 'subheader'
                    },
                    {
                        absolutePosition: start(24, 63, true),
                        stack: [
                            {
                                svg: plotSvg,
                            },
                            {
                                absolutePosition: start(76, 6, true),
                                stack: [
                                    {
                                        absolutePosition: start(0, 2),
                                        svg: circle('#F2D9D8', '#D96473')
                                    },
                                    {
                                        absolutePosition: start(18, 2),
                                        text: "AI-generated",
                                        style: "small",
                                    },
                                    {
                                        absolutePosition: start(0, 26),
                                        text: aiPercent + "%", style: 'digit',
                                    }
                                ],
                            },
                            {
                                absolutePosition: start(106, 0, true),
                                stack: [
                                    {
                                        absolutePosition: start(0, 2),
                                        svg: circle('#DAF2D8', '#42B45B')
                                    },
                                    {
                                        absolutePosition: start(18, 2),
                                        text: "Human-written",
                                        style: "small",
                                    },
                                    {
                                        absolutePosition: start(0, 26),
                                        text: humanPercent + "%", style: 'digit',
                                    }
                                ],
                            },
                            {
                                absolutePosition: start(106, 0, true),
                                stack: [
                                    {
                                        absolutePosition: start(0, 2),
                                        svg: circle('#F6DC99', '#D6C953')
                                    },
                                    {
                                        absolutePosition: start(18, 2),
                                        text: "Mixed",
                                        style: "small",
                                    },
                                    {
                                        absolutePosition: start(0, 26),
                                        text: (100 - aiPercent - humanPercent) + "%", style: 'digit',
                                    }
                                ],
                            }
                        ],
                    },
                ],
                absolutePosition: {x: 16, y: heightCalc()},
            },
        ]
    let textHeight = 64 + (text.length / 82 + (text.match(/\n/g) || []).length + 1) * 17;
    content = [...content,
        // TEXT DETAILS
        {
            canvas: [
                {
                    ...rectOpt,
                    h: 94,
                },
            ],
            absolutePosition: {x: 16, y: heightCalc(options.breakdownHeight + options.blocksGap)},
        },
        {
            stack: [
                {
                    margin: [20, 20, 0, 0],
                    text: 'Text details', style: 'subheader'
                },
                {
                    margin: [20, 8],
                    columns: [
                        {
                            width: "33%",
                            text: [{text: 'Sentences count: ', style: "bold"}, text.split("\n").length], style: "text"
                        },
                        {
                            width: "33%",
                            text: [{text: 'Words count: ', style: "bold"}, countWords(text)], style: "text"
                        },
                        {
                            width: "33%",
                            text: [{text: 'Characters count: ', style: "bold"}, text.length], style: "text"
                        }
                    ],
                    style: 'text',
                },
            ],
            absolutePosition: {x: 16, y: heightCalc()},
        },
        // SCANNED TEXT
        {
            canvas: [
                {
                    ...rectOpt,
                    h: Math.min(textHeight, 330)
                },
            ],
            absolutePosition: {x: 16, y: heightCalc(options.detailsHeight + options.blocksGap)},
            // margin: [0, 8, 0, 0]
        },
        {
            stack: [

                {
                    margin: [20, 20, 0, 0],
                    text: 'Scanned text', style: 'subheader',
                    link: "https://its-ai.org"
                },
                {
                    margin: [20, 8],
                    text: scannedText,
                    style: 'text',
                },
            ],
            absolutePosition: {x: 16, y: heightCalc()},
        }
    ]
    // textHeight -= 330
    // let pageNo = 1;
    // while (textHeight > 0) {
    //     content = [...content,
    //         { text: '', pageBreak: 'before' },
    //
    //         {
    //             canvas: [
    //                 {
    //                     ...rectOpt,
    //                     h: Math.min(options.height, textHeight)
    //                 },
    //             ],
    //             absolutePosition: {x: 16, y: 16},
    //         },
    //     ]
    //     console.log("add page")
    //     pageNo++;
    //     textHeight -= options.height - 20
    // }

    const docDefinition = {
        pageSize: {
            width: 595,
            height: 842
        },
        pageMargins: [16, 24],
        background: function (currentPage, pageSize) {
            console.log(pageSize)
            return {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: pageSize.width,
                        h: 842,
                        color: '#edeff1',
                    },
                ],
            }
        },
        content: content,
        styles: {
            header: {
                fontSize: 24,
                bold: true,
            },
            subheader: {
                fontSize: 20,
                bold: true,
            },
            text: {
                fontSize: 14,
                color: "#5C5E64"
            },
            link: {
                fontSize: 18,
                color: "#1a0dab"
            },
            bold: {
                bold: true,
                fontSize: 14,
                color: "#5C5E64"
            },
            digit: {
                fontSize: 18,
                color: '#080C1E',
            },
            small: {
                fontSize: 12,
                color: "#A6A8B0"
            }
        },
    };
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.download("scan_report.pdf");

    // pdfDocGenerator.getBuffer((buffer) => {
    //     fs.writeFileSync('scan_report.pdf', buffer);
    // });
}

export const createScanReportPDF = _createScanReportPDF;


// _createScanReportPDF("abc", 10, 20, false)
